import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=616e7b5d"
import script from "./ingredient.vue?vue&type=script&lang=js"
export * from "./ingredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports